import React from 'react';
import { TripProvider } from '../context/TripContext';
import { RouteProvider } from '../context/RouteContext';

const TripLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return <>
        <TripProvider>
            <RouteProvider>
                {children}
            </RouteProvider>
        </TripProvider>
    </>;
};

export default TripLayout;
